<template>
  <div id="creator_agency_apply">
    <van-nav-bar :title="$t('title.become_agent')" placeholder safe-area-inset-top @click-left="onClickLeft" left-arrow v-if="is_navigation_bar"/>
    <van-row>
      <van-col span="22" offset="1" class="creator_agency_apply_bg">
        <van-col span="22" offset="1" class="creator_agency_apply_bg_title">{{ $t('column.agency_policy') }}</van-col>
        <van-col span="22" offset="1" class="creator_agency_apply_bg_center">{{ $t('column.abundant_share_ratio_vast_bonus') }}</van-col>
        <van-col span="12" offset="8" class="creator_agency_apply_bg_btn">
          <van-button color="#FF61F5" size="mini" round plain hairline @click="view_details">  {{ $t('column.view_details')}} > </van-button>
        </van-col>
      </van-col>
      <van-col span="22" offset="1" class="creator_agency_apply_instructions">
        <van-col  span="22" offset="1"class="creator_agency_apply_instructions_title">
          1. {{ $t('column.become_agency') }}, <span>{{ $t('column.creator_role_will_canceled')}}</span>
        </van-col>
        <van-col  span="22" offset="1" class="creator_agency_apply_instructions_title">
          2. {{ $t('column.clickon_above_agent_policy_policies') }}
        </van-col>
      </van-col>
      <van-col span="22" offset="1" class="creator_agency_apply_information"> {{ $t('column.describe_agent_information')}}</van-col>
      <van-col span="22" offset="1" class="creator_agency_apply_from">
        <van-col span="22" offset="1" class="creator_agency_apply_from_title"> {{ $t('column.agency_name')}}</van-col>
        <van-col span="22" offset="1" class="creator_agency_apply_from_title">
          <van-field v-model="form.name" class="creator_agency_apply_from_input" :placeholder="$t('column.please_enter')" />
        </van-col>
        <van-col span="22" offset="1" class="creator_agency_apply_from_title"> {{ $t('column.real_name') }}</van-col>
        <van-col span="22" offset="1" class="creator_agency_apply_from_title">
          <van-field v-model="form.real_name" class="creator_agency_apply_from_input" :placeholder="$t('column.please_enter')" />
        </van-col>

        <van-col span="22" offset="1" class="creator_agency_apply_from_title"> {{ $t('column.select_country') }}</van-col>
        <van-col span="22" offset="1" class="creator_agency_apply_from_title">
          <van-cell :title="country_name" is-link arrow-direction="down" @click="CountShow = true">
            <template #default>
             {{ country_title }}
            </template>
          </van-cell>
        </van-col>

        <van-col span="22" offset="1" class="creator_agency_apply_from_title">{{ $t('column.email')}}</van-col>
        <van-col span="22" offset="1" class="creator_agency_apply_from_title">
          <van-field v-model="form.email" class="creator_agency_apply_from_input" :placeholder="$t('column.please_enter')" />
        </van-col>
        <van-col span="22" offset="1" class="creator_agency_apply_from_title">{{ $t('column.telegram_id')}}</van-col>
        <van-col span="22" offset="1" class="creator_agency_apply_from_title">
          <van-field v-model="form.telegram_id" class="creator_agency_apply_from_input" :placeholder="$t('column.please_enter')" />
        </van-col>
        <van-col span="22" offset="1" class="creator_agency_apply_from_title"> {{ $t('column.document_number')}}</van-col>
        <van-col span="22" offset="1" class="creator_agency_apply_from_title">
          <van-field v-model="form.document_number" class="creator_agency_apply_from_input" :placeholder="$t('column.please_enter')" />
        </van-col>


        <van-col span="22" offset="1" class="creator_agency_apply_from_title">{{ $t('column.attachment')}}</van-col>
        <van-col span="22" offset="1" class="creator_agency_apply_from_title">
          <van-col span="11">
            <uploadImage
                ref="uploader"
                class="creator_agency_apply_from_upload"
                v-if="iscos"
                :imageUrl="form.front_photo"
                :cos-config="cosConfig"
                :upload-text="$t('column.choose_id_card_front_photo')"
                @successUploadImage="handleSuccess"
                @errorUploadImage="handleError"
            />
          </van-col>
          <van-col span="11" offset="2">
            <uploadImage
                class="creator_agency_apply_from_upload"
                ref="uploader2"
                v-if="iscos"
                :cos-config="cosConfig"
                :imageUrl="form.back_photo"
                :upload-text="$t('column.choose_id_card_back_photo')"
                @successUploadImage="handleSuccess2"
                @errorUploadImage="handleError"
            />
          </van-col>

        </van-col>
        <van-col span="22" offset="1" class="creator_agency_apply_from_title">{{ $t('column.attachment')}} 2</van-col>
        <van-col span="22" offset="1" class="creator_agency_apply_from_title">
          <uploadImage
              ref="uploader3"
              v-if="iscos"
              :cos-config="cosConfig"
              :imageUrl="form.document_hand_img"
              :upload-text="$t('column.selfe_with_document_hand')"
              @successUploadImage="handleSuccess3"
              @errorUploadImage="handleError"
          />
        </van-col>

        <van-col span="22" offset="1" class="creator_agency_apply_from_title"> {{ $t('column.whatsapp_number')}}</van-col>
        <van-col span="22" offset="1" class="creator_agency_apply_from_title">
          <van-field v-model="form.whatsapp_number" class="creator_agency_apply_from_input" :placeholder="$t('column.please_enter')" />
        </van-col>

        <van-col span="22" offset="1" class="creator_agency_apply_from_checked">
          <van-checkbox v-model="checked" checked-color="#ca48fb" icon-size="16px">{{ $t('column.read_agree_palicy')}}</van-checkbox>
        </van-col>
        <van-col span="22" offset="1" class="creator_agency_apply_from_btn">
          <van-button color="linear-gradient(to left, #FF61F5, #A529FF)" :disabled="checked ? false : true" block @click="luck_btn">{{ $t('column.submit')}}</van-button>
        </van-col>
      </van-col>
    </van-row>
    <van-popup v-model="CountShow" position="bottom" :style="{ height: '60%',width: '100%' }">
      <van-picker
          show-toolbar
          :columns="country_list"
          @cancel="CountShow = false"
          value-key="en_short_name"
          :confirm-button-text="$t('btn.confirm')"
          :cancel-button-text="$t('btn.cancel')"
          @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>
<script>
import '@/assets/css/style.css'
import axios from 'axios'
import Toast from "vant/lib/toast"
import uploadImage from '@/components/upload_image.vue';
import {Dialog} from "vant";

export default {
  components: { uploadImage },
  data() {
    return {
      form:{
        name: '',
        real_name: '',
        country_code: '',
        email: '',
        telegram_id: '',
        front_photo: '',
        back_photo: '',
        document_hand_img: '',
        document_number: '',
        whatsapp_number: '',
      },
      checked: false,
      cosConfig: {
        tmpSecretKey: undefined,
        tmpSecretId: undefined,
        bucket: undefined,
        region: undefined,
        sessionToken: '',
        domain: '',
      },
      iscos:false,
      country_name: undefined,
      country_title: undefined,
      country_list: [],
      is_navigation_bar: false,
      CountShow: false
    }
  },
  created() {
    this.is_navigation_bar = this.$route.query.is_navigation_bar ==1 ? true : false // 是否展示顶部导航栏
    if (this.is_navigation_bar == false) {
       document.title = this.$t('title.become_agent')
    }
    this.init()
    this.getcosConfig()
    this.getCountryList()
  },
  methods: {
    onConfirm(val) {
      this.country_name = val.en_short_name
      this.country_title = val.alpha_2_code + '( ' + val.num_code + ')'
      this.form.country_code = val.num_code
      this.CountShow = false
      console.log(val)
    },
    init(){
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=creator&act=creator_agency_application_status",{ params:{ uid: uid, token: token }}).then(res =>{
        console.log(res.data)
        if(res.data.status===1){
          if (res.data.data.is_application === '0') {
            this.creator_success()
          } else if (res.data.data.is_application === '1') {
            if (this.is_navigation_bar) {
              // 已审核通过
              this.$router.push({path: '/creator_agency', query: {uid: uid, token: token}});
            }
            
          }
        }
      })
    },
    getCountryList(){
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=app&act=get_country_list").then(res =>{
        console.log(res.data)
        if(res.data.status===1){
          this.country_list = res.data.list
        }else{
          this.$emit('errorUploadImage', res.data.error)
        }
      })
    },
    getcosConfig(){
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=app&act=getCosSTS",{ params:{ uid: uid, token: token }}).then(res =>{
        console.log(res.data)
        if(res.data.status===1){
          this.cosConfig = res.data.data.sts
          this.iscos = true
        }else{
          this.$emit('errorUploadImage', res.data.error)
        }
      })
    },
    handleSuccess(url) {
      // 上传成功
      console.log('====handleSuccess====')
      console.log(url)
      this.form.front_photo = url
    },
    handleSuccess2(url) {
      // 上传成功
      console.log('====handleSuccess====')
      console.log(url)
      this.form.back_photo = url
    },
    handleSuccess3(url) {
      // 上传成功
      console.log('====handleSuccess====')
      console.log(url)
      this.form.document_hand_img = url
    },
    handleError(err) {
      console.log('====handleError====')
      console.log(err)
      console.log('55555555555')
      // 上传失败
      Toast(err);
    },
    onClickLeft() {
      // 拦截关闭h5
      window.location.href="bogolive://exit"
    },
    view_details () {
      const token = this.$route.query.token;
      const uid = this.$route.query.uid
      this.$router.push({path: '/creator_agency_apply_details', query: {uid: uid, token: token, is_navigation_bar: this.$route.query.is_navigation_bar }});
    },
    creator_success () {
      if (this.is_navigation_bar) {
        const token = this.$route.query.token;
        const uid = this.$route.query.uid
        this.$router.push({path: '/creator_success', query: {uid: uid, token: token, is_navigation_bar: this.$route.query.is_navigation_bar }});
      }
    },
    luck_btn () {
      Dialog.confirm({
        title: this.$t('column.apply_for_activation'),
        confirmButtonText: this.$t('btn.confirm'),
        cancelButtonText: this.$t('btn.cancel'),
        confirmButtonColor: '#AE2CF1',
      }).then(() => {
        this.form.uid = this.$route.query.uid
        this.form.token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=creator&act=creator_agency_application_add", {
          params: this.form
        }).then(res =>{
          console.log(res.data)
          if (res.data.status === 2){
            this.creator_success()
          }else{
            Toast(res.data.error)
            if (res.data.status === 1) {
              this.creator_success()
            }
          }
        })
      }).catch(() => {
        // on cancel
      })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/creator_agency_apply.vue